import React, { useState } from "react";
import { Tooltip } from "reactstrap";

const GenericTooltip = props => {
  const [id] = useState(`Tooltip-${Math.floor(Math.random() * 100000)}`);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <>
      <div id={id} style={{ display: "contents" }}>
        {props.children}
      </div>
      <Tooltip
        placement="auto"
        target={id}
        hideArrow={true}
        isOpen={tooltipOpen}
        toggle={toggle}
      >
        {props.msg}
      </Tooltip>
    </>
  );
};

export default GenericTooltip;
